import React from 'react';

export default function QRGenerator({
  defaultUrl = 'https://passenger.cabsafe.taxi',
  driverName = 'CabSafe Driver',
}) {
  const printUrl = `/api/qr/print?url=${encodeURIComponent(defaultUrl)}&name=${encodeURIComponent(driverName)}`;

  const openScanCard = (event) => {
    event.preventDefault();
    window.location.assign(printUrl);
  };

  return (
    <div className="qr-tool">
      <div className="tool-heading">
        <p>Driver Portal</p>
        <h2>Driver Scan Card</h2>
      </div>

      <a
        className="primary-action scan-card-action"
        href={printUrl}
        onClick={openScanCard}
      >
        Generate Scan Card
      </a>
    </div>
  );
}
